import { DIALECT_BLOCKCHAIN_SDK_TYPE_SOLANA } from '../../sdk/constants';
export const SOLANA_ED25519_TOKEN_SIGNER_ALG = `${DIALECT_BLOCKCHAIN_SDK_TYPE_SOLANA}-ed25519`;
export const SOLANA_ED25519_TOKEN_SIGNER_ALG_BACKWARD_COMPATIBLE = 'ed25519';
export class SolanaEd25519TokenSigner {
    constructor() {
        this.alg = SOLANA_ED25519_TOKEN_SIGNER_ALG;
    }
}
export class DialectWalletAdapterSolanaEd25519TokenSigner extends SolanaEd25519TokenSigner {
    constructor(dialectWalletAdapter) {
        super();
        this.dialectWalletAdapter = dialectWalletAdapter;
    }
    get subject() {
        return this.dialectWalletAdapter.publicKey.toBase58();
    }
    get subjectPublicKey() {
        return this.dialectWalletAdapter.publicKey;
    }
    async sign(payload) {
        return {
            payload,
            signature: await this.dialectWalletAdapter.signMessage(payload),
        };
    }
}
//# sourceMappingURL=solana-ed25519-token-signer.js.map